import { useRouter } from '@/hooks/routes';
import { useMemo } from 'react';
export function useIsAppQuery() {
  const router = useRouter()

  const isApp = useMemo(() => {
    return Boolean(router.query?.app === '1')
  }, [router.query])

  return isApp
}
